import React, { useState, useEffect } from "react";
//import * as _ from "lodash";

import Logo from "./ui/Logo";
import Footer from "./ui/Footer";

import {
  getDateFormatDescription,
  LOCALES,
  LOCALE_DESC_MAP,
  getLanguageFlag,
  estimateUserCountry,
  COUNTRY_US,
  COUNTRY_CA,
  COUNTRY_GB,
  COUNTRY_IE,
  COUNTRY_NO,
  COUNTRY_SE,
  COUNTRY_DK,
  COUNTRY_GL,
  COUNTRY_IS,
  COUNTRY_FO,
  COUNTRY_IN,
  COUNTRY_PK,
  COUNTRY_ID,
  COUNTRY_SG,
  COUNTRY_MY,
  COUNTRY_NZ,
} from "./util/localisation";

import {
  DATEFORMAT_EN,
  DATEFORMAT_EN_US,
  DATEFORMAT_EN_CA,
  DATEFORMAT_ES,
  DATEFORMAT_ES_US,
  DATEFORMAT_FR,
  DATEFORMAT_SCOTLAND,
  DATEFORMAT_WALES,
  DATEFORMAT_IM,
  DATEFORMAT_IE,
  DATEFORMAT_IS,
  DATEFORMAT_PK,
  DATEFORMAT_NO,
  DATEFORMAT_SE,
  DATEFORMAT_GL,
  DATEFORMAT_FO,
  DATEFORMAT_DK,
  DATEFORMAT_IN,
  DATEFORMAT_ID,
  DATEFORMAT_MY,
  DATEFORMAT_CN,
  DATEFORMAT_MAORI1,
  DATEFORMAT_MAORI2,
  DATEFORMAT_JAVANESE,
  DATEFORMAT_TAMIL,
  DATEFORMAT_MARATHI,
  DATEFORMAT_TELUGU,
  DATEFORMAT_GUJARATI,
  DATEFORMAT_PUNJABI,
  DATEFORMATS,
  THEME_LIGHT,
  THEME_DARK,
  ANSWERMODE_SUBMIT,
  PRACTICEFORMAT_ISO,
  PRACTICEFORMAT_LONGMONTH,
} from './util/constants';
import {
  getDateFormat,
  setDateFormat,
  getPracticeFormat,
  setPracticeFormat,
  getTheme,
  setTheme,
  getAnswerMode,
  setAnswerMode,
  getDeviceDefaultIsDark,
  addSettingsChangeListener,
  removeSettingsChangeListener,
} from "./util/settings";

import {
  pad2,
  applyDateFormat,
  DISPLAY_FORMAT_LONGMONTH,
  DISPLAY_FORMAT_LONGMONTH_MDY
} from './QuizDay';

import "./Settings.css";

const langsSort = (a, b) => {
  const strA = LOCALE_DESC_MAP[a]
    .toUpperCase()
    .replace(/Č/g, "C")
    .replace(/Í/g, "I");
  const strB = LOCALE_DESC_MAP[b]
    .toUpperCase()
    .replace(/Č/g, "C")
    .replace(/Í/g, "I");
  return strA < strB ? -1 : 1;
};

const makeLanguageOptions = (langs, sort) => {
  if (sort) {
    langs = langs.sort(langsSort);
  }
  return langs.map((dateFormat) => ({
    text:
      getLanguageFlag(dateFormat) +
      " " +
      LOCALE_DESC_MAP[dateFormat] +
      (LOCALES[dateFormat] ? "" : " ***** " + dateFormat),
    value: dateFormat,
  }));
};

const getDateFormatOptions = () => {
  const formats = [...DATEFORMATS];

  const extract = (format) => {
    const index = formats.indexOf(format);
    formats.splice(index, 1);
    return format;
  };

  const getEnglishOptGroup = () => {
    return {
      label: "English",
      options: makeLanguageOptions([
        extract(DATEFORMAT_EN),
        extract(DATEFORMAT_EN_US),
        extract(DATEFORMAT_EN_CA),
      ]),
    };
  };

  switch (estimateUserCountry()) {
    case COUNTRY_CA:
      return [
        {
          label: "Canada",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN_CA),
            extract(DATEFORMAT_FR),
          ]),
        },
        {
          label: "English (Other)",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN),
            extract(DATEFORMAT_EN_US),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_US:
      return [
        {
          label: "North America",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN),
            extract(DATEFORMAT_EN_US),
            extract(DATEFORMAT_EN_CA),
            extract(DATEFORMAT_ES_US),
            extract(DATEFORMAT_ES),
            extract(DATEFORMAT_FR),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_GB:
      return [
        {
          label: "British Isles",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN),
            extract(DATEFORMAT_WALES),
            extract(DATEFORMAT_SCOTLAND),
            extract(DATEFORMAT_IE),
            extract(DATEFORMAT_IM),
          ]),
        },
        {
          label: "English (Other)",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN_US),
            extract(DATEFORMAT_EN_CA),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_IE:
      return [
        {
          label: "Ireland",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN),
            extract(DATEFORMAT_IE),
          ]),
        },
        {
          label: "English (Other) & UK",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN_US),
            extract(DATEFORMAT_EN_CA),
            extract(DATEFORMAT_WALES),
            extract(DATEFORMAT_SCOTLAND),
            extract(DATEFORMAT_IM),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_NZ:
      return [
        {
          label: "New Zealand",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN),
            extract(DATEFORMAT_MAORI1),
            extract(DATEFORMAT_MAORI2),
          ]),
        },
        {
          label: "English (Other)",
          options: makeLanguageOptions([
            extract(DATEFORMAT_EN_US),
            extract(DATEFORMAT_EN_CA),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_NO:
    case COUNTRY_SE:
    case COUNTRY_DK:
    case COUNTRY_GL:
    case COUNTRY_FO:
    case COUNTRY_IS:
      return [
        getEnglishOptGroup(),
        {
          label: "Nordic",
          options: makeLanguageOptions([
            extract(DATEFORMAT_DK),
            extract(DATEFORMAT_FO),
            extract(DATEFORMAT_GL),
            extract(DATEFORMAT_NO),
            extract(DATEFORMAT_SE),
            extract(DATEFORMAT_IS),
          ]),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_IN:
      return [
        getEnglishOptGroup(),
        {
          label: "India",
          options: makeLanguageOptions(
            [
              extract(DATEFORMAT_IN),
              extract(DATEFORMAT_TAMIL),
              extract(DATEFORMAT_MARATHI),
              extract(DATEFORMAT_TELUGU),
              extract(DATEFORMAT_GUJARATI),
              extract(DATEFORMAT_PUNJABI),
            ],
            true
          ),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_PK:
      return [
        getEnglishOptGroup(),
        {
          label: "Pakistan",
          options: makeLanguageOptions(
            [
              extract(DATEFORMAT_PK),
              extract(DATEFORMAT_GUJARATI),
              extract(DATEFORMAT_PUNJABI),
            ],
            true
          ),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_ID:
      return [
        getEnglishOptGroup(),
        {
          label: "Indonesia",
          options: makeLanguageOptions(
            [
              extract(DATEFORMAT_ID),
              extract(DATEFORMAT_JAVANESE),
              extract(DATEFORMAT_MY),
            ],
            true
          ),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_MY:
      return [
        getEnglishOptGroup(),
        {
          label: "Malaysia",
          options: makeLanguageOptions(
            [
              extract(DATEFORMAT_MY),
              extract(DATEFORMAT_TAMIL),
              extract(DATEFORMAT_CN),
            ],
            true
          ),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    case COUNTRY_SG:
      return [
        getEnglishOptGroup(),
        {
          label: "Singapore",
          options: makeLanguageOptions(
            [
              extract(DATEFORMAT_MY),
              extract(DATEFORMAT_TAMIL),
              extract(DATEFORMAT_CN),
            ],
            true
          ),
        },
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
    default:
      return [
        getEnglishOptGroup(),
        {
          label: "Other",
          options: makeLanguageOptions(formats, true),
        },
      ];
  }
};

const DATEFORMAT_OPTIONS = getDateFormatOptions();

const ANSWERMODE_OPTIONS = [
  {
    value: "",
    text: "Instant",
  },
  {
    value: ANSWERMODE_SUBMIT,
    text: "Submit Button",
  },
];

const THEME_OPTIONS = [
  {
    value: THEME_LIGHT,
    text: "Light",
  },
  {
    value: THEME_DARK,
    text: "Dark",
  },
];

const PRACTICE_OPTIONS = [
  {
    value: "",
    text: "All date types",
  },
  {
    value: PRACTICEFORMAT_ISO,
    text: "ISO dates only (eg. %iso)",
  },
  {
    value: PRACTICEFORMAT_LONGMONTH,
    text: "Standard (eg. %s)",
  },
];

const getTodayStr = () => {
  const date = new Date();
  const year = date.getFullYear();
  const day = date.getDate();
  const month = date.getMonth()+1;
  return [year,pad2(month),pad2(day)].join('-');
}

const Settings = () => {
  const [dateFormat, setDateFormatFormValue] = useState(getDateFormat());
  const [practiceFormat, setPracticeFormatValue] = useState(
    getPracticeFormat() || ""
  );
  const [theme, setThemeFormValue] = useState(getTheme());
  const [answerMode, setAnswerModeFormValue] = useState(getAnswerMode());

  const onDateFormatChange = (evt) => {
    const value = evt.target.value;
    setDateFormat(value);
    setDateFormatFormValue(value);
  };

  const onPracticeFormatChange = (evt) => {
    const value = evt.target.value;
    setPracticeFormat(value);
    setPracticeFormatValue(value);
  };

  const onThemeChange = (evt) => {
    const value = evt.target.value;
    setTheme(value);
    setThemeFormValue(value);
  };

  const [isDeviceDefaultDark, setDeviceDefaultDark] = useState(
    getDeviceDefaultIsDark()
  );

  const onIsDarkChange = () => {
    setDeviceDefaultDark(getDeviceDefaultIsDark());
  };

  const onAnswerModeChange = (evt) => {
    const answerMode = evt.target.value;
    setAnswerMode(answerMode);
    setAnswerModeFormValue(answerMode);
  };

  useEffect(() => {
    addSettingsChangeListener("isDark", onIsDarkChange);

    // returned function will be called on component unmount
    return () => {
      removeSettingsChangeListener("isDark", onIsDarkChange);
    };
  }, []);

  const themeOptions = [
    {
      value: "",
      text: "Device Default (" + (isDeviceDefaultDark ? "dark" : "light") + ")",
    },
    ...THEME_OPTIONS,
  ];

  const localeCode = dateFormat.substr(0, 2);
  const locale = LOCALES[localeCode];

  const localeDateFormats = getDateFormatDescription(dateFormat);

  const todayStr = getTodayStr();
  const todayDateFull = applyDateFormat(
    todayStr,
    LOCALES[dateFormat].formatMDY ? DISPLAY_FORMAT_LONGMONTH_MDY : DISPLAY_FORMAT_LONGMONTH
  );

  const practiceOptions = PRACTICE_OPTIONS.map(
    opt => ({
      text: opt.text.replace(/%s/, todayDateFull)
        .replace(/%iso/, todayStr),
      value: opt.value
    })
  );

  return (
    <div className="Settings">
      <Logo />

      <label className="-select">
        <em>Background:</em>
        <Select options={themeOptions} value={theme} onChange={onThemeChange} />
      </label>

      <label className="-select">
        <em>Date Format:</em>
        <Select
          options={DATEFORMAT_OPTIONS}
          value={dateFormat}
          onChange={onDateFormatChange}
        />
      </label>

      <label className="-select">
        <em>Answer:</em>
        <Select
          options={ANSWERMODE_OPTIONS}
          value={answerMode || ""}
          onChange={onAnswerModeChange}
        />
      </label>

      <label className="-select">
        <em>Practice:</em>
        <Select
          options={practiceOptions}
          value={practiceFormat}
          onChange={onPracticeFormatChange}
        />
      </label>

      <div className={"-localeExample "} dir={locale.rtl ? "rtl" : null}>
        <span className="-formats">
          {getLanguageFlag(dateFormat)} &mdash;{" "}
          {localeDateFormats.map((part, index) => (
            <span key={index}>
              {index > 0 &&
                (index + 1 === localeDateFormats.length ? " and " : ", ")}
              <b>{part}</b>
            </span>
          ))}
        </span>

        <table>
          <thead>
            <tr>
              <th colSpan={3}>Months</th>
            </tr>
          </thead>
          <tbody>
            {new Array(12).fill(1).map((v, index) => (
              <tr key={index}>
                <th>{index + 1}</th>
                <td>{locale.longMonths[index]}</td>
                <td>{locale.shortMonths[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <table>
          <thead>
            <tr>
              <th colSpan={3}>Weekdays</th>
            </tr>
          </thead>
          <tbody>
            {new Array(7).fill(1).map((v, index) => (
              <tr key={index}>
                <th>{index}</th>
                <td>{locale.longWeekdays[index]}</td>
                <td>{locale.shortWeekdays[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <hr />

      <i className="-localesComingSoon">
        Note: More languages and improved localisation will be coming soon.
        Please contact me on Twitter if you see a translation mistake.{" "}
        <a href="https://twitter.com/benjoffe" target="_blank" rel="noreferrer">
          @benjoffe
        </a>
      </i>

      <Footer />
    </div>
  );
};

const Select = ({ options, ...props }) => (
  <select {...props}>
    {options.map((option, index) =>
      option.options ? (
        <optgroup label={option.label} key={index}>
          {option.options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.text}
            </option>
          ))}
        </optgroup>
      ) : (
        <option key={index} value={option.value}>
          {option.text}
        </option>
      )
    )}
  </select>
);

export default Settings;
